export const DEFNODE = 'DEFNODE';
export const registerType = {
  UNIT: 'unit',
  FLOW: 'flow',
  UNKNOWN: 'unknown',
};

// TODO 多语言
export const registerTypeMap = new Map([
  [registerType.FLOW, '工作流'],
  [registerType.UNIT, '生成器'],
  [registerType.UNKNOWN, '未知'],
]);

export const calcType = (type) => {
  switch (type) {
    case '1':
      return registerTypeMap.get(registerType.UNIT);
    case '2':
      return registerTypeMap.get(registerType.FLOW);
    default:
      return registerTypeMap.get(registerType.UNKNOWN);
  }
};

export const commuityUrls = {
  test: 'https://www-test.liblib.art/modelinfo/',
  pre: 'https://www-pre.liblib.art/modelinfo/',
  prod: 'https://www.liblib.art/modelinfo/',
};

export const flowScrollAreaId = 'flow-scroll-area';
